
import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const ClientService = {
  getLogo(id) {
    // on choisit le logo de l'enseigne du client en fonction de l'idEnseigne
    if (id === 1) {
      return 'https://nextcloud.hublot.io/apps/files_sharing/publicpreview/fHPcQ9CjB8nKD7c?file=/&fileId=7206955&x=1920&y=1080&a=true&etag=2d1f6d80180c85b3620e4f800ff4996e'
    } if (id === 2) {
      return 'https://nextcloud.hublot.io/apps/files_sharing/publicpreview/ig3dPB7Fc2BcWK9?file=/&fileId=7206956&x=1920&y=1080&a=true&etag=1fcacf56113e04fd8829572462fc1cc8'
    } if (id === 3) {
      return 'https://nextcloud.hublot.io/apps/files_sharing/publicpreview/WqxKX8do2WaNLf3?file=/&fileId=7206973&x=1920&y=1080&a=true&etag=d443e9a6327af5dc541e336195238b9a'
    } if (id === 4) {
      return 'https://nextcloud.hublot.io/apps/files_sharing/publicpreview/WMpc3pdpRAnSx3r?file=/&fileId=7100306&x=1920&y=1080&a=true&etag=63ce6fe1ec93ac8016c895ac08e74d48'
    } if (id === 5) {
      return 'https://nextcloud.hublot.io/apps/files_sharing/publicpreview/qwzpManrQm7HedC?file=/&fileId=7206982&x=1920&y=1080&a=true&etag=c32ee84d1940551c5c1630542b31799f'
    }
    return ''
  },
  get(context, clientid) {
    return fetchWithToken(`${config(context).clientService}/${clientid}`, {
      method: 'GET',
    }).then((body) => body.json())
  },
}
